var jsCart = (function($){

  var Tasks = {};
  Tasks = {
    updateItem: function() {
      var scope = document.getElementById('capContent');
      var a = scope.querySelectorAll('.cap-qty-update');
      var anc = Array.prototype.slice.call(a);
      anc.forEach(function(el, idx) {
        el.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var tar = ev.target;
          var itemId = tar.getAttribute('data-itemid');
          var itemQty = parseInt(tar.getAttribute('data-itemqty'), 10);
          var itemInv = parseInt(tar.getAttribute('data-iteminv'), 10);

          var $v = $(tar.parentNode).find("input[type='number']").val();
          var $val = parseInt($v, 10)
          var $status = $(tar.parentNode).find('.cap-qty-status-update');

          if (itemInv === 0 ||  $val <= itemInv) {
            if (itemQty !== $val && $val > 0) {
              // tar.setAttribute('disabled', 'true')
              tar.textContent = "Updating...";
              tar.setAttribute('data-updating', '1')

              Shopify.updateCartFromForm('cartForm', function(cart) {
                var loca = window.location;
                var loc = loca.protocol + '//' + loca.hostname + loca.pathname;
                window.location = loc;
              });

            } 
            if ($val < 1) {
              $status.addClass('badge-info');
              $status.text("Can't be 0");
              $(tar.parentNode).find("input[type='number']").val(itemQty);
              setTimeout(function(){
                $status.removeClass('badge-info');
                $status.text('');
              }, 3000);
            }
          } else {
            $status.addClass('badge-info');
            $status.text('Out of Stock');
            $(tar.parentNode).find("input[type='number']").val(itemQty);
            setTimeout(function(){
              $status.removeClass('badge-info');
              $status.text('');
            }, 3000);
          }
        })
      })
    }
  }
  Tasks.updateItem();

})(jQuery);